import IAmount from "@/module/main/dto/IAmount";
import IMerchantOrder from "@/module/main/dto/IMerchantOrder";

export default class MerchantOrder implements IMerchantOrder
{
    constructor(
        public totalPrice: IAmount | undefined,
        public name: string = "",
    )
    {
    }
}
